<template>
  <div class="box">
    <div class="box-header">
      <div style="padding-top: 20px">
        <span style="float:left;margin-left: 20px">
          <img src="../../assets/logo.png" style="width: 62px;border-radius: 50%">
        </span>
        <span style="color: white;float:left;margin-left: 15px">
          <p style="margin-top: 0">韩广志</p>
          <p style="font-size: 13px;color: #911101 ">产品经理</p>
        </span>
      </div>
    </div>

    <div class="box-body">
      <div class="box-body-header">
        <span>我负责的会议</span>
        <span @click="$router.push('/staging/liveConference')">更多 ></span>
      </div>
      <div class="box-body-div">
        <div :style="{backgroundImage:`url(https://yun-new-admin-1252497858.cos.ap-guangzhou.myqcloud.com/images/4605a676-cecd-4b4c-82df-8f15e6839c2e.jpg)`,width:135+'px',height:75 + 'px',float:'left',position:'relative'}">
          <div style="position: absolute;bottom: 0;width: 100%;font-size: 13px;background-color: black;opacity: 0.4;color: white">
            &nbsp;5月10日 19:00-20:45
          </div>
          <el-tag style="position: absolute;margin: 3px" size="mini">标签一</el-tag>
        </div>
        <div style="float: left;margin-left: 10px;width: 150px;">
          <div style="overflow:hidden;text-overflow:ellipsis;">
            [云ICU]轻盈云集张正111111111111111111111111111111
          </div>
          <div style="margin-top: 10px">
            <el-button size="mini" style="color: #45A5E6;border: #45A5E6 1px solid;padding-left: 5px;padding-right: 5px" @click="$router.push('/staging/dataStatistics')">
              <svg t="1686625462800" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4252" width="12" height="12"><path d="M29.123 500.22l385.974-354.828 226.778 217.835L854.496 119.66l-76.15-80.565 204.746-0.027-0.068 204.73-72.45-72.518-268.697 297.804-227.038-226.036L78.648 557.133l-49.523-56.912zM95.959 649.23h68.357v344.923H95.959V649.23z" p-id="4253" fill="#1296db"></path><path d="M368.903 452.754h68.357v541.397h-68.357V452.754zM641.723 585.921h68.357v408.231h-68.357V585.921zM914.605 380.714h68.357v613.438h-68.357V380.714z" p-id="4254" fill="#1296db"></path></svg>              数据统计</el-button>
            <el-button size="mini" style="color: #45A5E6;border: #45A5E6 1px solid;padding-left: 5px;padding-right: 5px">
              <svg t="1686637648868" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6591" width="13" height="12"><path d="M196.383562 1011.375342c-23.846575 0-49.09589-5.610959-72.942466-15.430137-11.221918-4.208219-18.235616-14.027397-21.041096-25.249315-2.805479-11.221918 1.40274-22.443836 9.819178-30.860274l65.928767-65.928767-23.846575-23.846575-67.331507 67.331507c-8.416438 8.416438-19.638356 11.221918-30.860274 9.819178-11.221918-1.40274-21.041096-9.819178-25.249315-19.638356C0 837.435616 14.027397 754.673973 68.734247 701.369863c42.082192-42.082192 102.4-60.317808 159.912328-50.49863l347.879452-347.879452c-22.443836-77.150685-1.40274-161.315068 56.109589-220.230137 65.928767-65.928767 162.717808-84.164384 246.882192-46.290411 11.221918 4.208219 18.235616 14.027397 21.041096 25.249315 2.805479 11.221918-1.40274 22.443836-9.819178 30.860274l-92.580822 92.580822 44.887671 44.887671 93.983562-93.983562c8.416438-8.416438 19.638356-11.221918 30.860274-9.819178 11.221918 1.40274 21.041096 9.819178 25.249315 19.638357 39.276712 84.164384 21.041096 185.161644-44.887671 251.09041-58.915068 58.915068-144.482192 79.956164-224.438356 54.70685l-347.879452 350.684931c8.416438 56.109589-9.819178 115.024658-50.498631 155.70411-35.068493 35.068493-81.358904 53.30411-129.052054 53.304109z m-40.679452-246.882191c8.416438 0 18.235616 2.805479 25.249315 9.819178l74.345205 74.345205c14.027397 14.027397 14.027397 36.471233 0 49.095891l-42.082192 42.082191c23.846575-2.805479 46.290411-14.027397 63.123288-32.263013 28.054795-28.054795 39.276712-70.136986 28.054795-108.010959-4.208219-14.027397 1.40274-29.457534 14.027397-37.873973l374.531507-374.531507c9.819178-9.819178 25.249315-12.624658 39.276712-7.013698 57.512329 25.249315 124.843836 12.624658 169.731507-32.263014 32.263014-32.263014 47.693151-75.747945 44.887671-119.232877l-75.747945 75.747946c-12.624658 12.624658-36.471233 12.624658-49.095891 0l-98.19178-93.983562c-14.027397-14.027397-14.027397-36.471233 0-49.095891l72.942465-72.942465c-42.082192-1.40274-82.761644 14.027397-113.621917 44.887671-43.484932 43.484932-57.512329 109.413699-33.665754 166.926027 5.610959 12.624658 2.805479 28.054795-7.013698 37.873973L263.715068 715.39726c-9.819178 9.819178-22.443836 12.624658-35.068493 8.416439-39.276712-12.624658-81.358904-1.40274-110.816438 28.054794-18.235616 18.235616-29.457534 43.484932-32.263014 67.331507l44.887672-44.887671c7.013699-7.013699 15.430137-9.819178 25.249315-9.819178z" fill="#1296db" p-id="6592"></path></svg>
              工具箱</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getMeetingData} from "@/service/staging";
import {getUserInfo} from "@/service/document_api";

export default {
  name: "Staging",
  data () {
    return {

    }// dataReturn
  },
  created() {
    this.getMeetingData()
  },
  methods: {
    async getMeetingData () {
      const userInfo = await getUserInfo('11')
      if (userInfo.code === 0) {
        console.log(userInfo)
      }
      let data = {
        name: '曹慧珍',
        pageNo: 1,
        pageSize: 100000,
      }
      const response = await getMeetingData(data)
      if (response.code === 0) {
        console.log(response.data)
      }else {
        this.$message.warning(response.message)
      }


    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  //background-color: #FFFFFF;
  width: 100%;
  min-height: 1000px;
  .box-header {
    width: 100%;
    height: 120px;
    background-color: black;
  }
  .box-body {
    width: 82%;
    height: 540px;
    box-shadow: 2px 1px 38px rgb(0 0 0 / 15%);
    border-radius: 15px;
    margin: 15px auto;
    padding: 15px;

    .box-body-header {
      color: #45A5E6;
      display: flex;
      justify-content: space-between;
    }
    .box-body-div {
      margin: 10px 0px;
    }
  }
}
</style>